// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"styles_searchWrapper__HBE8N","searchWrapper__arrowButton":"styles_searchWrapper__arrowButton__tevcV"};